import { useQuery } from '@tanstack/react-query';

export function useProjectsAnalyticsApprovalStatusReportQuery({
  params = {},
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projectsAnalytics', 'approvalStatusReports', params],
    queryFn: async () => {
      const response = await axios.post(
        '/projects_analytics/approval_status_reports',
        { approval_status_report: params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
